// extracted by mini-css-extract-plugin
export default {"menuBlock":"oK-z","title":"pK-z","nav":"qK-z","flexCell":"rK-z","facetLink":"sK-z"};